export const environment = {
  mobileMaxWidth: 849 // px
};
